import { render, staticRenderFns } from "./TemperatureOnOffDevice.vue?vue&type=template&id=bce5677c&scoped=true"
import script from "./TemperatureOnOffDevice.vue?vue&type=script&lang=js"
export * from "./TemperatureOnOffDevice.vue?vue&type=script&lang=js"
import style0 from "./TemperatureOnOffDevice.vue?vue&type=style&index=0&id=bce5677c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce5677c",
  null
  
)

export default component.exports